import React from "react"
import Layout from "../shared/components/organisms/layout/layout"
import SEO from "../shared/seo"
import ContactContent from "../components/organisms/contact-content/contact-content"
import "../shared/styles/index.scss"
import useLocaleMode from "../shared/hooks/useLocaleMode"

const Contactanos = props => {
  // send active modal to layout
  const [modalActive, setModalActive] = React.useState()
  // var news_info=props.dataProp
  const [isMobile, setMobileBool] = React.useState(false)
  // send active modal to layout
  const { locale } = useLocaleMode()
  const contactUsTitle = {
    "es-AR" : "Contactanos",
    "default": "Contáctanos"
  }
  const updateDimensions = () => {
    setMobileBool(window.innerWidth < 1024)
  }
  React.useEffect(() => {
    updateDimensions()
    window.addEventListener("resize", updateDimensions)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [])

  return (
    <Layout title={contactUsTitle[locale] || contactUsTitle["default"]} mobile={isMobile} modalActive={modalActive}>
      <SEO
        title={contactUsTitle[locale] || contactUsTitle["default"]}
        url={"/contactanos/"}
      />
      <ContactContent setModalActive={setModalActive} mobile={isMobile} />
    </Layout>
  )
}

export default Contactanos
